module.exports = __webpack_public_path__ + "img/mango-daiquiri.7dd131de.jpg";